import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as React from 'react';
import { LocalizeContextProps, withLocalize } from 'react-localize-redux';
import { connect } from 'react-redux';
import { DropdownItem } from 'reactstrap';
import { Dispatch } from 'redux';
import { deleteApplications } from '../../../stores/applications/actionCreators';
import { getApplicationName } from '../../../stores/applications/selectors';
import { hasPrivilege } from '../../../stores/auth/selectors';
import { RootState } from '../../../stores/store';
import { selected } from '../../../stores/tables/selectors';
import ConfirmModal from '../../common/modals/ConfirmModal';

interface Props extends LocalizeContextProps {
    getName: (id: string) => string;
    hasPrivilege: (privileges: string[]) => boolean;
    selected: string[];

    deleteApplications: (ids: string[]) => void;
}
interface State {
    showModal: boolean;
}

class DeleteApplicationsAction extends React.Component<Props, State> {
    public constructor(props: Props) {
        super(props);
        this.state = {
            showModal: false,
        };
    }

    public render() {
        const t = this.props.translate;
        if (this.props.hasPrivilege(['DELETE_APPLICATION', 'USER_ADMIN', 'SUPER_ADMIN'])) {
            return (
                <React.Fragment>
                    <DropdownItem
                        className="danger"
                        onClick={() => {
                            this.setState({ showModal: true });
                        }}
                    >
                        <FontAwesomeIcon icon={['fal', 'trash']} />
                        {t('applications.button.delete')}
                    </DropdownItem>
                    <ConfirmModal
                        header={t('applications.modal.delete.header') as string}
                        confirmText={t('applications.modal.delete.delete') as string}
                        buttonColor="danger"
                        isOpen={this.state.showModal}
                        confirm={() => {
                            this.props.deleteApplications(this.props.selected);
                        }}
                        cancel={() => { this.setState({ showModal: false }); }}
                    >
                        {t('.modal.delete.text') as string} <b>{this.getHandle()}</b>?
                    </ConfirmModal>
                </React.Fragment>
            );
        } else {
            return null;
        }
    }

    private getHandle = () => {
        const t = this.props.translate;
        if (this.props.selected.length !== 1) {
            return t(
                'applications.modal.delete.applications',
                { number: this.props.selected.length }
            );
        } else {
            return this.props.getName(this.props.selected[0]);
        }
    }
}

const mapStateToProps = (state: RootState) => ({
    getName: getApplicationName(state),
    hasPrivilege: hasPrivilege(state),
    selected: selected(state, 'applications'),
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
    deleteApplications: (ids: string[]) => dispatch(deleteApplications(ids)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withLocalize(DeleteApplicationsAction));